import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'sidebarNav.home',
    defaultMessage: 'Home',
  },
  betaLabel: {
    id: 'beta.pill',
    defaultMessage: 'Beta',
  },
  notebooksLabel: {
    id: 'sidenav.myNotebooks',
    defaultMessage: 'My Notebooks',
  },
  marketplace: {
    id: 'sidenav.marketplace',
    defaultMessage: 'Marketplace',
  },
});
